import type { FieldValues } from 'react-hook-form';
import { createAction } from '@reduxjs/toolkit';

export const getLicenseTypeByCode = createAction<{
  licenseTypeCode: string;
  id?: number;
  generateConfiguration?: boolean;
}>('getLicenseTypeByCode');

export const getLicenseTypeById = createAction<number>('getLicenseTypeById');
export const getParentLicenseTypeById = createAction<number>('getParentLicenseTypeById');

export const getLpcoFormDetails = createAction<number>('getLpcoFormDetails');

export const getFilexData = createAction<string>('getFilexData');

export const getParentLpco = createAction<number>('getParentLpco');

export const getUserReferenceNumber = createAction('getUserReferenceNumber');

export const lpcoOperation = createAction<FieldValues>('lpcoOperation');

export const getValidationConfig = createAction('getValidationConfig');
